export default __webpack_public_path__ + "static/media/tradingPurchase.9b707450.svg";